export const HTTP_STATUSES_CODES = {
  OK: 200,
};
